__turbopack_context__.v({
  "border-tab": "workDetails-module-scss-module__gWdWRG__border-tab",
  "border-title": "workDetails-module-scss-module__gWdWRG__border-title",
  "brief": "workDetails-module-scss-module__gWdWRG__brief",
  "container": "workDetails-module-scss-module__gWdWRG__container",
  "detail-container": "workDetails-module-scss-module__gWdWRG__detail-container",
  "detail-item": "workDetails-module-scss-module__gWdWRG__detail-item",
  "details": "workDetails-module-scss-module__gWdWRG__details",
  "fade-in-u0abku6": "workDetails-module-scss-module__gWdWRG__fade-in-u0abku6",
  "name": "workDetails-module-scss-module__gWdWRG__name",
  "name-icon": "workDetails-module-scss-module__gWdWRG__name-icon",
  "sublist-container": "workDetails-module-scss-module__gWdWRG__sublist-container",
  "tabs": "workDetails-module-scss-module__gWdWRG__tabs",
  "title": "workDetails-module-scss-module__gWdWRG__title",
  "title-icon": "workDetails-module-scss-module__gWdWRG__title-icon",
});
